module.exports = __webpack_public_path__ + "static/steps-to-solve-system-design-questions-077692f9ce56a366d22bc039a9b2d716.png";